import React from 'react'
import { OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap'
import PropTypes from 'prop-types'
import cuid from 'cuid'

const InfoTooltipWhite = ({ text, trigger = undefined, iconClass = 'ml-2', placement = 'right', onClickHandler }) => {
  const id = cuid()
  return (
    <OverlayTrigger
      rootClose
      placement={placement}
      trigger={trigger}
      onClick={onClickHandler}
      overlay={
        <Popover id={id}>
          <p>{text}</p>
        </Popover>
      }
    >
      <Glyphicon glyph={`info-sign  ${iconClass}`} />
    </OverlayTrigger>
  )
}

InfoTooltipWhite.propTypes = {
  text: PropTypes.any,
  trigger: PropTypes.any,
  iconClass: PropTypes.string,
  placement: PropTypes.string,
  onClickHandler: PropTypes.func
}

export default InfoTooltipWhite
